import {api} from 'services/api';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getProductCollectionsLocations = api.injectEndpoints({
  endpoints: builder => ({
    getProductCollectionsLocations: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `export/pdf/product-collections-locations`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{}>;

export const {useLazyGetProductCollectionsLocationsQuery} = getProductCollectionsLocations;
